import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, SimpleChanges, OnChanges, ChangeDetectorRef } from '@angular/core';
import { PaginationManager } from 'src/app/modules/shared/managers/paginationManager';
import { ChecklistItemViewModel } from 'src/app/modules/shared/models/checklists/checklistItemViewModel';
import { Constants } from 'src/app/modules/shared/models/constants';
import { UtilitiesService } from 'src/app/modules/shared/services/utilities.service';
import { T } from 'src/assets/i18n/translation-keys';
import { ChecklistHelperService } from '../services/checklist-helper-service.service';

@Component({
    selector: 'app-checklist-group-card',
    templateUrl: './checklist-group-card.component.html',
    styleUrls: ['./checklist-group-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChecklistGroupCardComponent implements OnInit, OnChanges {
  @Input() groupTitle: string;
  @Input() checklistItems: ChecklistItemViewModel[] = [];
  @Input() canEdit: boolean = true;
  @Input() expanded: boolean = false;
  @Input() draggable: boolean = false;
  @Input() loading: boolean = false;
  @Input() expandAsDrawer: boolean = false;
  @Output() expand = new EventEmitter<string>();
  @Output() itemCompleted = new EventEmitter<ChecklistItemViewModel>();
  @Output() viewItem = new EventEmitter<ChecklistItemViewModel>();
  @Output() attachmentsClicked = new EventEmitter<void>();

  public paginationId: string;
  public completedChecks: number = 0;
  public totalAttachmentsCount: number = 0;
  public readonly T = T;

  constructor(private readonly paginationManager: PaginationManager,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly utilitiesService: UtilitiesService,
    private readonly checklistHelperService: ChecklistHelperService) {}

  ngOnInit(): void {
    this.paginationId = this.paginationManager.generateID();
    this.checksCompletition();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.checklistItems?.currentValue) {
      this.checksCompletition();
    }
  }

  checksCompletition(): void {
    this.completedChecks = this.utilitiesService.countMatching(this.checklistItems, item => this.checklistHelperService.isCompleted(item));;
    this.calculateTotalAttachmentsCount();
    this.changeDetectorRef.markForCheck();
  }

  calculateTotalAttachmentsCount(): void {
    this.totalAttachmentsCount = this.checklistItems.reduce((total, item) => {
      return total + (item.attachmentsCount || 0);
    }, 0);
  }

  onExpandClicked() {
    this.expand.emit(this.groupTitle);
  }

  onView(item: ChecklistItemViewModel) {
    this.viewItem.emit(item);
  }

  updateItem(item: ChecklistItemViewModel) {
    this.itemCompleted.emit(item);
  }

  onAttachmentsClicked(event: Event) {
    event.stopPropagation();
    this.attachmentsClicked.emit();
  }

  public get isMobile(): boolean {
    return window.innerWidth < Constants.xs;
  }

  getAriaLabel(): string {
    let label = `${this.groupTitle} checklist group. ${this.completedChecks} of ${this.checklistItems.length} checks completed.`;

    if (this.totalAttachmentsCount > 0) {
      label += ` ${this.totalAttachmentsCount} attachment${this.totalAttachmentsCount > 1 ? 's' : ''}.`;
    }

    label += ` Double tap to open.`;

    return label;
  }
}
